import { render, staticRenderFns } from "./ArgInputSaleList.vue?vue&type=template&id=6b45b710&scoped=true"
import script from "./ArgInputSaleList.vue?vue&type=script&lang=ts"
export * from "./ArgInputSaleList.vue?vue&type=script&lang=ts"
import style0 from "./ArgInputSaleList.vue?vue&type=style&index=0&id=6b45b710&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b45b710",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b45b710')) {
      api.createRecord('6b45b710', component.options)
    } else {
      api.reload('6b45b710', component.options)
    }
    module.hot.accept("./ArgInputSaleList.vue?vue&type=template&id=6b45b710&scoped=true", function () {
      api.rerender('6b45b710', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/scripts/ArgInputSaleList.vue"
export default component.exports